interface Props {
  mobile: string;
  code: string;
  countdown: number;
  sending: boolean;
  error?: string;
  onMobile: (value: string) => void;
  onCode: (value: string) => void;
  onSend: () => void;
}
export function SMSCodeField({
  mobile,
  code,
  countdown,
  sending,
  error,
  onMobile,
  onCode,
  onSend
}: Props) {
  return (
    <>
      <label>
        手机号
        <input
          autoComplete="tel"
          inputMode="numeric"
          value={mobile}
          maxLength={11}
          onChange={(e) => onMobile(e.target.value.replace(/\D/g, ''))}
          placeholder="请输入 11 位手机号"
        />
      </label>
      <div className="sms-row">
        <label>
          验证码
          <input
            autoComplete="one-time-code"
            inputMode="numeric"
            value={code}
            maxLength={6}
            onChange={(e) => onCode(e.target.value.replace(/\D/g, ''))}
            placeholder="4-6 位验证码"
          />
        </label>
        <button
          type="button"
          className="btn secondary sms-button"
          disabled={sending || countdown > 0 || !/^1\d{10}$/.test(mobile)}
          onClick={onSend}
        >
          {sending ? '发送中…' : countdown > 0 ? `${countdown}s 后重发` : '获取验证码'}
        </button>
      </div>
      {error && (
        <p className="modal-error" role="alert">
          {error}
        </p>
      )}
    </>
  );
}
